export const SUCCESS = '1';
export const FAILED = '0';
export const SECRET_KEY = 'Appscasa@2024@Jaitpur$$';
export const FACEBOOK_URL = 'https://www.facebook.com/appscasa/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/appscasa';
export const isDev = process.env.NODE_ENV === 'development';
